import { Typography } from "@mui/material";
import DefaultPage from "./default-page.jsx";

import "./landing.css";

export default function Landing() {
  return (
    <DefaultPage>
      <div className="Landing">
        <br />
        <Typography variant="h1" sx={{ color: "#130D17", textAlign: "center" }}>
          Herzlich Willkommen bei der SGI!
        </Typography>
        <br />
        <img src="/images/Gruppenbild.jpg" alt="Gruppenbild" />
        <br />
        <Typography sx={{ paddingInline: "10%", textAlign: "center" }}>
          Die Schanzer Gemeinschaft Ingolstadt ist ein Verein der sich aus einem
          lange bestehenden Freundeskreis entwickelt hat. Der Verein verfolgt
          laut seiner Satzung folgenden Zweck:
        </Typography>
        <br />
        <Typography
          sx={{
            fontStyle: "italic",
            textAlign: "center",
            paddingInline: "10%",
          }}
        >
          '§2 Satz 2: Der Zweck des Vereins ist die Förderung des sozialen und
          kulturellen Lebens in Ingolstadt. Der Satzungszweck wird insbesondere
          verwirklicht durch die Teilnahme und das Veranstalten von öffentlichen
          und vereinsinternen Veranstaltungen.'
        </Typography>
        <br />
        <Typography sx={{ paddingInline: "10%", textAlign: "center" }}>
          Neben kulturellen Veranstaltungen soll auch die Teilnahme an sozialen
          Projekten zum Vereinsalltag gehören. Die Mitglieder des Vereins sind
          daher aufgerufen sich aktiv an der Gestaltung des Vereinslebens zu
          beteiligen. Wir freuen uns über Ihr Interesse und laden Sie ein, sich
          auf unserer Homepage über unsere Aktivitäten zu informieren. Wenn Sie
          Fragen haben steht ihnen unser Kontaktformular zur Verfügung.
        </Typography>
      </div>
      <br />
    </DefaultPage>
  );
}
